import axios from "axios";


export const getAllTaskRequest = async () => {
  return await axios.get("https://node-express-five.vercel.app/");
};
export const deleteTaskRequest = async (id) => {
  return await axios.delete("https://node-express-five.vercel.app/" + id);
};
export const postTaskRequest = async (task) => {
  return await axios.post("https://node-express-five.vercel.app/", task);
};
export const putTaskRequest = async (id, task) => {
  return await axios.put("https://node-express-five.vercel.app/" + id , task);
};



